import React from "react";
import ResourcePage from "@/components/ResourcePage";
import { Badge } from "@/components/Common";

export default function NewsAdmin() {
  return (
    <ResourcePage
      endpoint="/updates"
      testidPrefix="update"
      eyebrow="Website"
      title="News & Updates (Website)"
      subtitle="Posts published here appear instantly on the public website /site/news."
      ctaLabel="New post"
      fields={[
        { name: "title", label: "Title", required: true },
        { name: "body", label: "Body", type: "textarea", required: true },
        { name: "category", label: "Category", type: "select", default: "news",
          options: ["news", "announcement", "promotion"] },
      ]}
      columns={[
        { key: "title", label: "Title", render: (i) => (
          <div>
            <div className="font-medium text-gray-900">{i.title}</div>
            <div className="text-xs text-gray-500 line-clamp-1 max-w-md">{i.body}</div>
          </div>
        ) },
        { key: "category", label: "Category", render: (i) => <Badge tone="emerald">{i.category}</Badge> },
        { key: "is_published", label: "Status", render: (i) => <Badge tone={i.is_published === false ? "gray" : "emerald"}>{i.is_published === false ? "Draft" : "Live"}</Badge> },
        { key: "created_by_name", label: "Posted by" },
      ]}
      searchKeys={["title", "body"]}
    />
  );
}
